var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',{staticClass:"container"},[_c('editor-content',{attrs:{"editor":_vm.editor}}),_vm._v(" "),_c('div',{class:{
            'character-count': true,
            'character-count--warning':
                _vm.editor.storage.characterCount.characters() === _vm.limit,
        }},[_vm._v("\n\n        "+_vm._s(_vm.editor.storage.characterCount.characters())+" /\n        "+_vm._s(_vm.limit)+" characters\n        ")]),_vm._v(" "),_c('div',{ref:"textbox",staticClass:"hidden"},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }